export default "__VITE_ASSET__DvwbZI8u__"